import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-analytics-details',
  templateUrl: './help-google-analytics-details.component.html'
})
export class HelpGoogleAnalyticsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
